<template>
<div class="create_quiz">
    <div class="row" >
    <div class="row glocal-config-content" >
        <div class="col-form-inner col-6 col-md-12 col-lg-12">
        <div class="form-group">
            <div class="form-label">
            <label>Nome do Quiz </label>
            </div>
            <div class="form-input">
            <input type="text" class="form-control" v-model="name" placeholder="Nome do Quiz">
            </div>
        </div>
        </div>
        <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
            <div class="form-label">
            <label>Nota de Aprovação</label>
            </div>
            <div class="form-input">
            <input type="text" class="form-control" v-model="minimumgrade" placeholder="7">
            </div>
        </div>
        </div>
        <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
            <div class="form-label">
            <label>Nota máxima </label>
            </div>
            <div class="form-input">
            <input type="text" class="form-control" v-model="maximumgrade" placeholder="10">
            </div>
        </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
        <div class="form-group">
            <label class="label-form">
            Status
            </label>
            <select  class="select-mode" v-model="statusquiz">
            <option value="" disabled selected>Selecione uma opção</option>
            <option value="ativo">Ativo</option>
            <option value="desabilitado">Desabilitado</option>
            </select>
        </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
        <div class="form-group align-button">
            <button @click="save()" class="btn btn-success">Salvar</button>
            <button @click="retrun()" class="btn btn-danger">Fechar</button>
        </div>
        </div>
    </div>
    
    </div>

</div>
</template>
<script>
export default {
    data() {   
    return {
        name:'',
        minimumgrade:'',
        maximumgrade:'',
        statusquiz:'',

    };
    },
    methods: {
    save(){
        const data = {
            name: this.name,
            minimumgrade: this.minimumgrade,
            maximumgrade: this.maximumgrade,
            statusquiz: this.statusquiz
        }

        this.$router.push('/dashboard/cursos')
    }, 
    retrun(){
        this.$router.push('/dashboard/cursos')
    }
},
    
};
</script>
<style>
@import './quiz.css'
</style>